// Dark mode helper
const DM_KEY = "finvault_dark_mode";

export function getDarkMode() {
  return localStorage.getItem(DM_KEY) === "true";
}
export function setDarkMode(val) {
  localStorage.setItem(DM_KEY, val ? "true" : "false");
}

// Light/Dark theme tokens
export function theme(dark) {
  return {
    bg:        dark ? "#07101F" : "#F0F4FF",
    card:      dark ? "#0F172A" : "#FFFFFF",
    cardAlt:   dark ? "#111C2F" : "#F8FAFF",
    border:    dark ? "#27364F" : "#E2E8F0",
    text:      dark ? "#F8FAFC" : "#1E1B4B",
    textSub:   dark ? "#D7E1F0" : "#94A3B8",
    textMuted: dark ? "#A8B5C8" : "#CBD5E1",
    input:     dark ? "#101A2D" : "#F8FAFF",
    nav:       dark ? "rgba(7,16,31,.96)" : "#FFFFFF",
    hero:      dark ? "rgba(148,163,184,0.10)" : "rgba(255,255,255,0.13)",
  };
}
